<template>
  <div class="sync-editor">
    <div style="grid-area: header">
      <label>Název synchronizace</label>
      <input v-model="name" class="asd-input"
             type="text"
             required="required" maxlength="100"
      />
    </div>


    <div style="grid-area: syncType">
      <label>Typ synchronizace</label>
      <Multiselect v-model="type"
                   label="name"
                   trackBy="id"
                   valueByPath="id"
                   :options="SYNC_TYPES"
                   :returnAsSingle="true"
                   :max="1"
                   @input="prepareData"
      ></Multiselect>
    </div>

    <div v-show="type" style="grid-area: propertyType">
      <label>Navázaná vlastnost</label>
      <Multiselect v-model="propertyType"
                   label="name"
                   trackBy="id"
                   valueByPath="id"
                   :options="propertyTypes"
                   :max="1"
      ></Multiselect>
    </div>

    <div v-show="propertyType && propertyType.length" style="grid-area: projectType">
      <label>Pro typy projektu</label>
      <Multiselect v-model="projectType"
                   label="name"
                   trackBy="id"
                   valueByPath="id"
                   :options="projectTypes"
                   :max="-1"
      ></Multiselect>
    </div>

    <div v-show="propertyType && propertyType.length" style="grid-area: taskType">
      <label>Pro typy úkolu</label>
      <Multiselect v-model="taskType"
                   label="name"
                   trackBy="id"
                   valueByPath="id"
                   :options="taskTypes"
                   :max="-1"
      ></Multiselect>
    </div>

    <div v-show="(projectType && projectType.length) || (taskType && taskType.length)" style="grid-area: fields">
      <div class="fields-grid fields-grid-heading">
        <div>
          Položka ve flexibee
        </div>
        <div>
          Směr
        </div>
        <div>
          Vlastnost(i) v ASD
        </div>
      </div>
      <div v-for="f in typeFields" :key="f" class="fields-grid">
        <div>{{ f }}</div>
        <button
          class="btn"
          :class="[direction[f] === 'down' ? 'btn-down': 'btn-up']"
          @click="toggleFieldDirection(f)"
        >
          <template v-if="direction[f] === 'up'">
            &lt;=
          </template>
          <template v-if="direction[f] === 'down'">
            =&gt;
          </template>
        </button>
        <Multiselect
          label="name"
          trackBy="key"
          valueByPath="key"
          :options="propertyTypes"
          :max="direction[f] === 'down' ? -1 : 1"
          :value="field[f]"
          @input="setFieldPropertyType(f, $event)"
        ></Multiselect>
      </div>
    </div>

    <div v-show="projectType.length || taskType.length" style="grid-area: buttons; text-align: center;">
      <button class="asd-btn-confirm" style="width: 300px" @click="input">
        Uložit
      </button>
    </div>

    <div style="grid-area: help">
      <div class="form-info-text">
        <span class="badge badge-pill badge-warning">Název synchronizace</span>
        Jakýkoliv krátký a výstižný text pro pojmenování synchronizace - něco jako předmět v emailu.
        Slouží také jako identifikátor v případě chybových hlášení.
      </div>
      <div class="form-info-text">
        <span class="badge badge-pill badge-warning">Navázaná vlastnost</span>
        Vlastnost která se použije jako hodnota pro identifikaci vzdálené služby.
        Analogicky k SQL se jedná o cizí klíč.
      </div>
      <div class="form-info-text">
        <span class="badge badge-pill badge-warning">Pro typy projektu</span>
        Synchronizace bude probíhat pouze pro vybrané typy projektů.
      </div>
      <div class="form-info-text">
        <span class="badge badge-pill badge-warning">Pro typy úkolu</span>
        Synchronizace bude probíhat pouze pro vybrané typy úkolů.
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext.vue'
import { mapGetters } from 'vuex'

const SYNC_TYPES = _ => [
    {
        id: 'flexibee_zakazka_kod',
        name: 'Flexibee zakázka pomocí políčka KOD',
        fields: [
            'nazev',
            'popis',
            'nakladyPredpoklad',
            'ziskPredpoklad',
            'nazevA',
            'nazevB',
            'nazevC',
            'poznam',
            'platiOd',
            'platiDo',
            'varSym',
            'stitky',
            'cisObj',
            'cisSml',
            'stavZakazky',
            'typZakazky',
            'kontaktOsoba',
            'mena',
            'datZahaj',
            'datKonec',
            'termin',
            'firma',
        ],
    },
]

export default {
    name: 'FlexibeeEditorEntry',
    components: {
        Multiselect,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            type: '',
            name: '',
            propertyType: [],
            projectType: [],
            taskType: [],
            field: {},
            direction: {},
        }
    },
    computed: {
        ...mapGetters([
            'propertyTypes',
            'projectTypes',
            'taskTypes',
        ]),
        ...{ SYNC_TYPES },
        typeFields() {
            return _.get(_.find(SYNC_TYPES(), { id: this.type }), 'fields', [])
        },
    },
    mounted() {
        this.type = _.get(this.value, 'type', '')
        this.name = _.get(this.value, 'name', '')
        this.propertyType = _.get(this.value, 'propertyType', [])
        this.projectType = _.get(this.value, 'projectType', [])
        this.taskType = _.get(this.value, 'taskType', [])
        this.field = _.get(this.value, 'field', {})
        this.direction = _.get(this.value, 'direction', {})
    },
    methods: {
        setFieldPropertyType(field, propertyTypes) {
            this.$set(this.field, field, propertyTypes)
        },
        toggleFieldDirection(field) {
            if (_.get(this.direction, field, 'up') === 'up') {
                this.$set(this.direction, field, 'down')
            } else {
                this.$set(this.direction, field, 'up')
            }
        },
        prepareData() {
            _.each(this.typeFields, f => {
                console.info(f)
                this.$set(this.direction, f, 'down')
                this.$set(this.field, f, [])
            })
        },
        input() {
            this.$emit('input', {
                type: this.type,
                name: this.name,
                propertyType: this.propertyType,
                projectType: this.projectType,
                taskType: this.taskType,
                field: this.field,
                direction: this.direction,
            })
        },
    },
}
</script>

<style scoped>
.sync-editor {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px;
    grid-template-rows: auto;
    grid-template-areas:
        "header header"
        "syncType propertyType"
        "projectType taskType"
        "fields fields"
        "buttons buttons"
        "help help";
    width: fit-content;
    margin: 0 auto;
}
.fields-grid {
    display: grid;
    grid-template-columns: 46% 8% 46%;
    justify-content: space-between;
    justify-items: stretch;
    margin: 12px auto 0 auto;
}
.fields-grid-heading {
    text-align: center;
    font-weight: bold;
    margin-top: 25px;
}
.fields-grid > *:last-child {
    margin-left: 10px;
}
.fields-grid > div {
    align-self: center;
}
.btn-up {
    background-color: var(--orange)
}
.btn-down {
    background-color: var(--cyan)
}
h5 {
    text-align: center;
    font-size: 12pt;
    color: var(--blue);
}
</style>

